/*
* MLMI Locator
*/

/* global google */

const MAP_SELECTOR = '.locator-map'

export const MAP_STYLE = [{"featureType":"all","elementType":"labels","stylers":[{"visibility":"off"},{"color":"#f49f53"}]},{"featureType":"administrative.locality","elementType":"all","stylers":[{"visibility":"on"},{"weight":"0.01"},{"color":"#637381"}]},{"featureType":"administrative.neighborhood","elementType":"all","stylers":[{"color":"#637381"},{"visibility":"on"},{"weight":"0.01"}]},{"featureType":"landscape","elementType":"all","stylers":[{"color":"#ffffff"},{"lightness":-7},{"gamma":"10.00"}]},{"featureType":"poi","elementType":"all","stylers":[{"color":"#ffffff"}]},{"featureType":"poi.business","elementType":"all","stylers":[{"lightness":38}]},{"featureType":"poi.government","elementType":"all","stylers":[{"lightness":46}]},{"featureType":"poi.medical","elementType":"geometry.fill","stylers":[{"lightness":38}]},{"featureType":"poi.park","elementType":"all","stylers":[{"lightness":39}]},{"featureType":"poi.school","elementType":"all","stylers":[{"lightness":35}]},{"featureType":"poi.sports_complex","elementType":"all","stylers":[{"lightness":32}]},{"featureType":"road","elementType":"all","stylers":[{"lightness":43}]},{"featureType":"road.highway","elementType":"all","stylers":[{"color":"#dbdde0"}]},{"featureType":"road.highway","elementType":"geometry.fill","stylers":[{"weight":"0.66"}]},{"featureType":"road.arterial","elementType":"all","stylers":[{"visibility":"on"},{"color":"#dadce0"}]},{"featureType":"road.local","elementType":"geometry.fill","stylers":[{"weight":1.3},{"lightness":16}]},{"featureType":"road.local","elementType":"geometry.stroke","stylers":[{"lightness":-10}]},{"featureType":"transit","elementType":"all","stylers":[{"lightness":38}]},{"featureType":"transit.line","elementType":"all","stylers":[{"color":"#813033"},{"lightness":22},{"visibility":"off"}]},{"featureType":"transit.station","elementType":"all","stylers":[{"visibility":"off"}]},{"featureType":"water","elementType":"all","stylers":[{"color":"#e3e5e9"},{"saturation":-69},{"gamma":0.99},{"lightness":43}]}]

const MAP_OPTIONS = {
  selectors: {
    form: '.locator-form',
    list: '.locations-list',
    where: 'input[name="where"]',
    radius: 'input[name="radius"]',
  },
  mapOptions: {
    zoomControl: false,
  },
  basicOptions: {
    zoom: 8,
    maxZoom: 20,
    minZoom: 1,
    lat: 47.123573,
    lng: -70.825643,
    mapStyle: MAP_STYLE,
    autoFitBounds: true,
    scrollwheel: true,
    enableGeolocation: false,
    enablePositionMarker: false,
    putSearchParametersInURL: false,
    searchAfterGeolocation: false,
  },
  clusterOptions: {
    useClusters: false,
  },
  bubbleOptions: {
    useBubbles: true,
    useBubblesOnHover: true,
    shadowStyle: 0,
    padding: 0,
    borderRadius: 0,
    borderWidth: 0,
    backgroundColor: '#000000',
    minWidth: 240,
    maxWidth: 240,
    minHeight: 20,
    maxHeight: 200,
    arrowSize: 5,
    arrowPosition: 50,
    arrowStyle: 0,
    disableAutoPan: true,
    hideCloseButton: true,
  },
  getMarkerIcon: function(location) {
    let markerIcon = {
      url: '/img/elements/location-marker.png',
      height: 22,
      width: 22,
      anchorX: 11,
      anchorY: 11,
    }
    if (location.filters.indexOf('boutique-etoile') !== -1) {
      markerIcon = {
        url: '/img/elements/location-star.png',
        height: 32,
        width: 32,
        anchorX: 16,
        anchorY: 16,
      }
    }
    return markerIcon
  },
  filterMarkers: function(markers) {
    markers = markers.sort(function(a, b) {
      return b.filters.length - a.filters.length
    })
    return markers
  },
}

let self

export default {
  locator: undefined,
  locations: [],
  hasSearched: false,

  init() {
    self = this
    this.attachEvents()
  },

  attachEvents() {
    self = this
    if ($(MAP_SELECTOR).length) {
      // Calculate legend height for map sizing
      $(window).on('load resize orientationchange', function() {
        const legendHeight = $('.locator-legend').outerHeight() + 'px';
        $('body').css('--legend-height', legendHeight);
      })
      if ($.mlmi.mobile.isMobile) {
        MAP_OPTIONS.basicOptions.zoom = 5
      }
      self.locator = $(MAP_SELECTOR).MLMI_Locator(MAP_OPTIONS, function(location) {
        let template = $('.locator-bubble-template').clone()
        template.find('.info-bubble__title').html(location.display_name)
        if (location.filters.indexOf('boutique-etoile') !== -1) {
          template.find('.info-bubble__location-type').show()
        } else {
          template.find('.info-bubble__location-type').hide()
        }
        return template.html()
      })

      self.locator.on('search_started', function() {
        self.hasSearched = true
        $('.locator-spinner').addClass('locator-spinner--visible')
        $('.locations-list').css('opacity', '0.35')
        let scrollTarget = $('.locator-map').offset().top - $('.header').outerHeight(false)
        if (scrollTarget - $(window).scrollTop() > 200) {
          $('body, html').scrollTo(scrollTarget)
        }
      })

      self.isProgrammaticPan = false;

      self.locator.on('map_drag zoom_out', function() {
        if (!self.hasSearched) {
          return
        }
        if (self.isProgrammaticPan) {
          return
        }
        $('.locator-relocate').addClass('locator-relocate--visible')
      })

      self.locator.on('list_loaded', function() {
        self.initListMarkers();
        $('.locator-spinner').removeClass('locator-spinner--visible');
        $('.locations-list').css('opacity', '1')
      });

      $('.map-container__zoom-out').on('click', function() {
        let targetZoom = self.locator.map.getZoom() - 1
        if (targetZoom >= MAP_OPTIONS.basicOptions.minZoom) {
          self.locator.map.setZoom(targetZoom)
        }
      })
      $('.map-container__zoom-in').on('click', function() {
        let targetZoom = self.locator.map.getZoom() + 1
        if (targetZoom <= MAP_OPTIONS.basicOptions.maxZoom) {
          self.locator.map.setZoom(targetZoom)
        }
      })

      $(document).ready(function() {
        var popup = $('.featured-message--style-columns');
        var confirmBtn = popup.find('.btn--primary');
        if (popup.length) {
          popup.attr('aria-hidden', 'false');
        }
        confirmBtn.on('click', function(e) {
          e.preventDefault();
          popup.attr('aria-hidden', 'true');
        });

        $('.locator-legend__toggle').on('click', function(e) {
          e.preventDefault();

          var $legend = $(this).next('.locator-legend');

          if ($.mlmi.mobile.isMobile) {
            // Mobile: fade in/out
            $legend.toggleClass('--active');
          } else {
            // Desktop: slide up/down
            if ($legend.hasClass('--active')) {
                $legend.removeClass('--active');
                $legend.css('height', '0px');
            } else {
                var fullHeight = $legend.prop('scrollHeight');
                $legend.addClass('--active');
                $legend.css('height', fullHeight + 'px');
            }
          }
      });

      });

      self.locator.on('form_search', function() {
        $('input[name="radius"]').val(30)
        self.locator.options.basicOptions.autoFitBounds = true
      })

      self.initListMarkers = function() {
        $('.locations-list__item[data-id]').each(function() {
          let list_item = $(this)
          list_item.id = list_item.data('id')
          list_item.find('.location-item__directions, .locations-list__item__title').click(function() {
            var marker = self.locator.getMarker(list_item.id)
            self.locator.current.infoWindow.setContent(self.locator.infoWindowContent(marker.location));
            $('.locations-list__item').removeClass('bg-cream')
            $('.locations-list__item[data-id=' + marker.location.id + ']').addClass('bg-cream')
            if ($.mlmi.mobile.isMobile) {
              $('body, html').scrollTo(0, 500, 6, 'easeInOutQuart')
            } else {
              $('body, html').scrollTo($('.locations-list__item[data-id=' + list_item.id + ']').offset().top - $('.header').outerHeight(false) - 30, 500, 15)
            }
            self.locator.current.infoWindow.open(self.locator.map, marker)
            var markerPosition = marker.getPosition();
            self.isProgrammaticPan = true;
            $('.locator-relocate').removeClass('locator-relocate--visible');
            self.locator.map.panTo(markerPosition);
            self.zoomToShowMarkers(marker);
            setTimeout(function() {
              self.isProgrammaticPan = false;
            }, 100);
            return false;
          })
        })
      }
      self.initListMarkers()

      self.zoomToShowMarkers = function(clickedMarker) {
        let targetZoom = 14;
        const minZoom = 8;

        // Start at zoom 14 and check if we see at least 3 markers
        for (let zoom = 14; zoom >= minZoom; zoom--) {
          self.locator.map.setZoom(zoom);
          let bounds = self.locator.map.getBounds();
          let visibleCount = 0;

          // Count how many markers are visible at this zoom level
          self.locator.markers.forEach(function(marker) {
            if (marker.getVisible() && bounds && bounds.contains(marker.getPosition())) {
              visibleCount++;
            }
          });

          // If we see at least 3 markers, stop here
          if (visibleCount >= 3) {
            targetZoom = zoom;
            break;
          }
        }

        // Set the final zoom level
        self.locator.map.setZoom(targetZoom);
      }

      self.locator.on('marker_clicked', function(event, locator, marker) {
        $('.locations-list__item').removeClass('bg-cream')
        $('.locations-list__item[data-id=' + marker.location.id + ']').addClass('bg-cream')
        $('body, html').scrollTo($('.locations-list__item[data-id=' + marker.location.id + ']').offset().top - $('.header').outerHeight(false) - 30, 500, 15)
        var markerPosition = marker.getPosition();
        self.isProgrammaticPan = true;
        $('.locator-relocate').removeClass('locator-relocate--visible');
        self.locator.map.panTo(markerPosition);
        self.zoomToShowMarkers(marker);
        setTimeout(function() {
          self.isProgrammaticPan = false;
        }, 100);
      })

      $('.locator-relocate').on('click', function() {
        $('.locator-relocate').removeClass('locator-relocate--visible')
        let newPosition = self.locator.map.getCenter()
        let mapBounds = self.locator.map.getBounds()
        $('input[name="where"]').val('')
        $('input[name="radius"]').val(Math.max(30, Math.ceil(google.maps.geometry.spherical.computeDistanceBetween(mapBounds.getSouthWest(), mapBounds.getNorthEast()) / 1000 / 2 * 1.15)))
        self.locator.current.lng = newPosition.lng()
        self.locator.current.lat = newPosition.lat()
        self.locator.options.basicOptions.autoFitBounds = false
        self.locator.submitSearch()
      })
    }
  },
}
